import React from "react";
import { motion } from "framer-motion";
import { achievements, education } from "../../data/portfolio";
import { Trophy, GraduationCap } from "lucide-react";

export const Achievements = () => {
  return (
    <section id="achievements" data-testid="achievements-section" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-10">
        <div>
          <div className="text-xs font-mono-display uppercase tracking-widest text-[color:var(--primary)] mb-3">
            /05 · Recognition
          </div>
          <h2 className="font-mono-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-semibold mb-8">
            Wins & <span className="text-gradient-neon">recognition</span>.
          </h2>

          <div className="space-y-4">
            {achievements.map((a, i) => (
              <motion.div
                key={a}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                data-testid={`achievement-${i}`}
                className="glass rounded-xl p-4 flex items-start gap-3 hover:border-[color:var(--accent)]/40 transition-all"
              >
                <div className="w-9 h-9 rounded-lg bg-[color:var(--accent)]/10 flex items-center justify-center text-[color:var(--accent)] shrink-0">
                  <Trophy size={16} />
                </div>
                <div className="text-sm text-white/80 font-body leading-relaxed">{a}</div>
              </motion.div>
            ))}
          </div>
        </div>

        <div>
          <div className="text-xs font-mono-display uppercase tracking-widest text-[color:var(--primary)] mb-3">
            /06 · Education
          </div>
          <h2 className="font-mono-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-semibold mb-8">
            Foundations.
          </h2>

          <div className="space-y-4">
            {education.map((e, i) => (
              <motion.div
                key={e.degree}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                data-testid={`education-${i}`}
                className="glass rounded-xl p-5 hover:border-[color:var(--primary)]/40 transition-all"
              >
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-lg bg-[color:var(--primary)]/10 flex items-center justify-center text-[color:var(--primary)] shrink-0">
                    <GraduationCap size={16} />
                  </div>
                  <div>
                    <div className="font-mono-display text-white">{e.degree}</div>
                    <div className="text-sm text-white/60 font-body mt-1">{e.school}</div>
                    <div className="text-xs font-mono-display uppercase tracking-widest text-white/40 mt-1">{e.period}</div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Achievements;